import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'sip-manipulation-groups-summary',
  templateUrl: './sip-manipulation-groups-summary.component.html',
  styleUrls: ['./sip-manipulation-groups-summary.component.scss']
})
export class SipManipulationGroupsSummaryComponent implements OnInit {

  sipManipulationGroup;
  @Input()
  set selection(selection: any) {
    this.initializeData(selection);
  }

  constructor() {
  }

  ngOnInit(): void {

  }

  private initializeData(selection: any): void {
    this.sipManipulationGroup = selection;
  }
}
